// Import Properties
export const IMPORT_PROPERTIES_REQUEST = 'IMPORT_PROPERTIES_REQUEST';
export const IMPORT_PROPERTIES_SUCCESS = 'IMPORT_PROPERTIES_SUCCESS';
export const IMPORT_PROPERTIES_FAILURE = 'IMPORT_PROPERTIES_FAILURE';

// Get All Locations
export const GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE';

// Add location
export const ADD_LOCATION_REQUEST = 'ADD_LOCATION_REQUEST';
export const ADD_LOCATION_SUCCESS = 'ADD_LOCATION_SUCCESS';
export const ADD_LOCATION_FAILURE = 'ADD_LOCATION_FAILURE';

// Remove location
export const REMOVE_LOCATION_REQUEST = 'REMOVE_LOCATION_REQUEST';
export const REMOVE_LOCATION_SUCCESS = 'REMOVE_LOCATION_SUCCESS';
export const REMOVE_LOCATION_FAILURE = 'REMOVE_LOCATION_FAILURE';

// Get Location By Id

export const GET_LOCATION_BY_ID_REQUEST = 'GET_LOCATION_BY_ID_REQUEST';
export const GET_LOCATION_BY_ID_SUCCESS = 'GET_LOCATION_BYI_D_SUCCESS';
export const GET_LOCATION_BY_ID_FAILURE = 'GET_LOCATION_BYID__FAILURE';

// add office hours time

export const ADD_TIME_REQUEST = 'ADD_TIME_REQUEST';
export const ADD_TIME_SUCCESS = 'ADD_TIME_SUCCESS';
export const ADD_TIME_FAILURE = 'ADD_TIME_FAILURE';

//edit office hours time

export const EDIT_TIME_REQUEST = ' EDIT_TIME_REQUEST';
export const EDIT_TIME_SUCCESS = 'EDIT_TIME_SUCCESS';
export const EDIT_TIME_FAILURE = 'EDIT_TIME_FAILURE';

//get office hours time

export const GET_TIME_ID_REQUEST = 'GET_TIME_ID_REQUEST';
export const GET_TIME_ID_SUCCESS = 'GET_TIME_ID_SUCCESS';
export const GET_TIME_ID_FAILURE = 'GET_TIME_ID_FAILURE';

export const CLEAR_PREVIOUS_LOCATION_DATA = 'CLEAR_PREVIOUS_LOCATION_DATA';

// Get location detail by ID
export const GET_LOCATION_DETAIL_BY_ID_REQUEST = 'GET_LOCATION_DETAIL_BY_ID_REQUEST';
export const GET_LOCATION_DETAIL_BY_ID_SUCCESS = 'GET_LOCATION_DETAIL_BY_ID_SUCCESS';
export const GET_LOCATION_DETAIL_BY_ID_FAILURE = 'GET_LOCATION_DETAIL_BY_ID__FAILURE';

// Get office hour logs
export const GET_OFFICE_HOURS_LOGS_REQUEST = 'GET_OFFICE_HOURS_LOGS_REQUEST';
export const GET_OFFICE_HOURS_LOGS_SUCCESS = 'GET_OFFICE_HOURS_LOGS_SUCCESS';
export const GET_OFFICE_HOURS_LOGS_FAILURE = 'GET_OFFICE_HOURS_LOGS_FAILURE';

// Get Location amenities
export const GET_LOCATION_AMENITIES_REQUEST = 'GET_LOCATION_AMENITIES_REQUEST';
export const GET_LOCATION_AMENITIES_SUCCESS = 'GET_LOCATION_AMENITIES_SUCCESS';
export const GET_LOCATION_AMENITIES_FAILURE = 'GET_LOCATION_AMENITIES_FAILURE';

export const CLEAR_LOCATION_AMENITIES = 'CLEAR_LOCATION_AMENITIES';

// create amenities
export const CREATE_AMENITIES_REQUEST = 'CREATE_AMENITIES_REQUEST';
export const CREATE_AMENITIES_SUCCESS = 'CREATE_AMENITIES_SUCCESS';
export const CREATE_AMENITIES_FAILURE = 'CREATE_AMENITIES_FAILURE';

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
